import { render, staticRenderFns } from "./LeadsPotentialTotalizer.vue?vue&type=template&id=97e1c390"
import script from "./LeadsPotentialTotalizer.vue?vue&type=script&lang=js"
export * from "./LeadsPotentialTotalizer.vue?vue&type=script&lang=js"
import style0 from "./LeadsPotentialTotalizer.vue?vue&type=style&index=0&id=97e1c390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports